var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.358 54.4203C91.4291 54.4203 93.7852 51.8351 93.446 48.9106L91.5391 31.8772C91.2549 29.3652 89.1005 27.4584 86.5153 27.3942L65.8698 27C63.7521 27 61.7994 28.201 61.0018 30.117L53.5944 47.8472C52.2009 51.1292 54.7312 54.7137 58.4349 54.6954L88.3855 54.347H88.358V54.4203Z",
    fill: "#FF9E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.342 50.9918C122.342 47.3614 119.39 44.4186 115.75 44.4278L54.4923 44.6844C49.2026 44.7028 44.5913 48.1773 43.1794 53.192L40.8692 65.7883C39.9249 69.1161 42.4277 72.3982 45.9572 72.389L115.805 72.0956C119.417 72.0773 122.342 69.1436 122.342 65.5316V50.9826V50.9918Z",
    fill: "#FF9E1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.342 62.0117L40.879 62.3784V65.5229C39.9255 69.0524 42.4558 72.4353 45.9762 72.4261L116.356 72.1328C119.675 72.1144 122.352 69.4283 122.352 66.1096V62.0117H122.342Z",
    fill: "#FF7915"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.9 52.0365C109.655 51.9998 117.062 59.2148 118.566 68.6482C118.85 70.4634 117.576 72.1044 115.935 72.1044L86.0298 72.2236C84.4163 72.2236 83.1328 70.5734 83.3987 68.7857C84.8472 59.3614 92.1904 52.064 100.927 52.0273H100.9V52.0365Z",
    fill: "#FF7915"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8861 52.2572C64.6412 52.2205 72.0211 59.4446 73.5246 68.8689C73.8088 70.6841 72.5345 72.3251 70.8935 72.3251L41.0438 72.4443C39.4303 72.4443 38.1193 70.7941 38.3852 69.0064C39.8336 59.5821 47.1494 52.2847 55.8861 52.248V52.2572Z",
    fill: "#FF7915"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.801 71.3163C111.773 65.3482 106.896 60.4619 100.91 60.4894C94.9231 60.5169 90.0551 65.3941 90.0826 71.408C90.1101 77.422 94.9873 82.2625 101.001 82.235C107.015 82.2075 111.828 77.3303 111.801 71.3163Z",
    fill: "#7A5FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9608 71.5361C66.9333 65.5679 62.0561 60.6816 56.0422 60.7091C50.0282 60.7366 45.1877 65.6138 45.2152 71.6277C45.2427 77.6417 50.1199 82.4822 56.1339 82.4547C62.1478 82.4272 66.9883 77.55 66.9608 71.5361Z",
    fill: "#7A5FFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.217 49.5701C82.528 49.5701 83.4998 48.4058 83.3714 47.0398L82.2988 36.873C82.1705 35.7453 81.2629 34.8102 80.1261 34.8194L71.4169 34.5811C70.4634 34.5811 69.6108 35.1953 69.3083 36.1212L65.8796 46.7098C65.4304 48.1675 66.4663 49.6985 68.0065 49.6985L81.217 49.5701Z",
    fill: "#FFEB5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCar);
export default __webpack_public_path__ + "static/media/card_car.af0df6c6336ed751c793a5b7ecd214b2.svg";
export { ForwardRef as ReactComponent };